import React from 'react';
import { motion } from 'framer-motion';
import { Award } from 'lucide-react';
export function ExpertValidation() {
  return <section className="py-20 bg-[#f4e4d7]/20" data-id="element-38">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row" data-id="element-40">
          <div className="md:w-1/3 bg-[#1e3a5f] p-8 flex flex-col items-center justify-center text-center" data-id="element-41">
            <div className="w-32 h-32 bg-gray-300 rounded-full mb-4 border-4 border-[#d4a574] overflow-hidden" data-id="element-42">
              {/* Placeholder for expert image */}
              <img src="https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?ixlib=rb-1.2.1&auto=format&fit=crop&w=400&q=80" alt="Experta Financiera" className="w-full h-full object-cover" data-id="element-43" />
            </div>
            <h3 className="text-white font-serif font-bold text-xl" data-id="element-44">
              Laura Méndez
            </h3>
            <p className="text-[#d4a574] text-sm mb-4" data-id="element-45">Estratega Financiera</p>
            <div className="flex items-center gap-2 bg-white/10 px-3 py-1 rounded-full" data-id="element-46">
              <Award className="w-4 h-4 text-[#d4a574]" data-id="element-47" />
              <span className="text-white text-xs" data-id="element-48">Certificada</span>
            </div>
          </div>

          <div className="md:w-2/3 p-8 md:p-12 flex flex-col justify-center" data-id="element-49">
            <h3 className="text-2xl font-serif font-bold text-[#1e3a5f] mb-4" data-id="element-50">
              "Las finanzas no tienen por qué ser complicadas"
            </h3>
            <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-51">
              He diseñado este pack pensando específicamente en las mujeres que
              sienten que los números "no son lo suyo". He eliminado toda la
              jerga técnica y me he enfocado en lo que realmente funciona en el
              día a día.
            </p>
            <p className="text-gray-600 leading-relaxed" data-id="element-52">
              No necesitas ser experta en matemáticas ni tener grandes ingresos.
              Solo necesitas un plan claro y la voluntad de cambiar tu historia
              financiera. Este es ese plan.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}